<div style="margin-top: 15px;">
  <div class="card p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
    <div class="p-datatable-header" *ngIf="'ROLE_OPERATOR' | userHasRole">
      <div class="flex flex-column sm:flex-row justify-content-between">
        <div class="flex flex-column lg:flex-row">
          <button
            [label]="'common.new' | transloco"
            pButton
            pRipple
            class="md:mr-2 p-button-primary mb-2 md:mb-0"
            routerLink="../../../alarms/triggers/new/DEVICE/{{device.uuid}}/{{device.tenant.uuid}}/{{device.organization.uuid}}"
            icon="pi pi-plus"
          ></button>
          <button
            (click)="confirmAndDeleteSelected()"
            *ngIf="('ROLE_OPERATOR' | userHasRole) && ((deviceTriggers && deviceTriggers.length > 0) || filtersFilled)"
            [disabled]="selected.length === 0"
            [label]="'common.delete' | transloco"
            class="p-button-danger mb-2 lg:mb-0 lg:mr-2"
            icon="pi pi-trash"
            pButton
            pRipple
          ></button>
          <p-toggleButton
            (click)="selected.length > 0 ? changeActiveStates() : null"
            *ngIf="('ROLE_OPERATOR' | userHasRole) && ((deviceTriggers && deviceTriggers.length > 0) || filtersFilled)"
            [(ngModel)]="activeButtonState"
            [disabled]="selected.length === 0"
            [offLabel]="'misc.setInactive' | transloco" [onLabel]="'misc.setActive' | transloco"
            class="mb-2 sm:mb-0"
            offIcon="pi pi-times"
            onIcon="pi pi-check"
            styleClass="w-full"
          ></p-toggleButton>
        </div>
        <div *ngIf="filtersFilled || (deviceTriggers && deviceTriggers.length > 0)">
          <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              (click)="filtersVisible = !filtersVisible"
              [label]="'common.filters' | transloco"
              class="p-button-secondary"
              icon="pi pi-sliders-h"
              pButton
            ></button>
          </div>
          <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              (click)="filtersVisible = !filtersVisible"
              [label]="'common.filters' | transloco"
              class="p-button-secondary filtersFilled"
              icon="pi pi-filter"
              pButton
            ></button>
          </div>
      </div>
    </div>
    <div class="flex" style="margin-top: 15px;" *ngIf="deviceTriggers && deviceTriggers.length == 0">
      <div class="w-full">
        <p class="text-xl text-center p-6 font-italic" style="font-weight: normal!important">{{'empty.triggers' | transloco}}</p>
      </div>
    </div>
    <p-table
      *ngIf="deviceTriggers && deviceTriggers.length > 0"
      [(first)]="first"
      [(rows)]="rows"
      [value]="deviceTriggers"
      [totalRecords]="totalTriggers"
      [responsive]="true"
      [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
      [paginator]="true"
      [rowsPerPageOptions]="[10,25,50]"
      [lazy]="true"
      [(selection)]="selected"
      (onLazyLoad)="onPageChange($event)"
      dataKey="dataKey"
      styleClass="p-datatable-striped"
      sortField="name"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="'ROLE_OPERATOR' | userHasRole" class="selection-column-width" scope="col"></th>
          <th class="selection-column-width" scope="col"></th>
          <th scope="col" pSortableColumn="name">
            {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
          <th scope="col" pSortableColumn="ownerUuid">
            {{'attribute.ruleType' | transloco}}<p-sortIcon field="ownerUuid"></p-sortIcon></th>
          <th scope="col" pSortableColumn="category">
            {{'attribute.category' | transloco}}<p-sortIcon field="category"></p-sortIcon></th>
          <th scope="col" pSortableColumn="active">
            {{'attribute.active' | transloco}}<p-sortIcon field="active"></p-sortIcon></th>
          <th scope="col" pSortableColumn="lastEvaluation">
            {{'attribute.result' | transloco}}<p-sortIcon field="lastEvaluation"></p-sortIcon></th>
          <th scope="col" pSortableColumn="evaluationDate">
            {{'attribute.evaluationDate' | transloco}}<p-sortIcon field="evaluationDate"></p-sortIcon></th>
          <th scope="col" *ngIf="'ROLE_OPERATOR' | userHasRole">
            {{'common.actions' | transloco}}</th>
        </tr>
      </ng-template>
      <ng-template let-expanded="expanded" let-trigger pTemplate="body">
        <tr *ngIf="!loadingTriggers">
          <td>
            <span class="p-column-title bold">{{ 'common.expand' | transloco }}</span>
            <button [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    [pRowToggler]="trigger"
                    class="p-button-text p-button-rounded p-button-plain"
                    pButton
                    pRipple
                    type="button"></button>
          </td>
          <td *ngIf="'ROLE_OPERATOR' | userHasRole">
            <span class="p-column-title bold">{{ 'common.select' | transloco }}</span>
            <p-tableCheckbox (click)="evaluateActiveButtonState()" [value]="trigger"></p-tableCheckbox>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
            {{trigger.name}}
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.ownerUuid' | transloco}}</span>
            <p *ngIf="trigger.ownerUuid">{{ "common.user" | transloco }}</p>
            <p *ngIf="!trigger.ownerUuid">{{ "menu.system" | transloco }}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.category' | transloco}}</span>
            <p>{{ 'model.triggerCategories.' + trigger.category.toLowerCase() | transloco }}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.active' | transloco}}</span>
            <p *ngIf="trigger.active">{{'common.active' | transloco}}</p>
            <p *ngIf="!trigger.active">{{'common.inactive' | transloco}}</p>
          </td>
          <td class="m-0" *ngIf="trigger.lastEvaluation != null && trigger.lastEvaluation != undefined">
            <span class="p-column-title bold">{{'attribute.result' | transloco}}</span>
            <p [className]="trigger.lastEvaluation ? 'success-color' : 'danger-color'">
              <i [className]="trigger.lastEvaluation ? 'pi pi-check' : 'pi pi-times'"></i>
              {{(trigger.lastEvaluation ? 'common.true' : 'common.false') | transloco}}
            </p>
          </td>
          <td class="m-0" *ngIf="trigger.lastEvaluation == null || trigger.lastEvaluation == undefined">
            <span class="p-column-title bold">{{'attribute.result' | transloco}}</span>
          </td>
          <td>
            <span class="p-column-title bold">{{'attribute.evaluationDate' | transloco}}</span>
            {{trigger.evaluationDate | customDate}}
          </td>
          <td *ngIf="'ROLE_OPERATOR' | userHasRole">
            <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
            <div class="flex justify-content-end">
              <button
                (click)="edit(trigger)"
                pButton
                pRipple
                class="p-button-rounded btn-primary-light mr-2"
                icon="pi pi-pencil"
              ></button>
              <button
                (click)="confirmAndDelete(trigger)"
                *ngIf="'ROLE_OPERATOR' | userHasRole"
                class="p-button-rounded btn-danger-light"
                icon="pi pi-trash"
                pButton
                pRipple
              ></button>
            </div>
          </td>
        </tr>
        <tr *ngIf="loadingTriggers">
          <td *ngIf="'ROLE_OPERATOR' | userHasRole" class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          <td *ngIf="'ROLE_OPERATOR' | userHasRole" class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
        </tr>
      </ng-template>
      <ng-template let-trigger pTemplate="rowexpansion">
        <tr>
          <td colspan="100">
            <div class="p-p-3 w-full">
              <p-table [value]="[trigger]" styleClass="w-full">
                <ng-template pTemplate="header">
                  <tr>
                    <th scope="col">
                      {{ 'attribute.measurementName' | transloco }}
                    </th>
                    <th scope="col">
                      {{ 'attribute.valueEvaluated' | transloco }}
                    </th>
                    <th scope="col">
                      {{ 'attribute.condition' | transloco }}
                    </th>
                  </tr>
                </ng-template>
                <ng-template let-triggerSingle pTemplate="body">
                  <tr>
                    <td>
                      <span class="p-column-title bold">{{ 'attribute.measurementName' | transloco }}</span>
                      <p
                        *ngIf="triggerSingle.entityType === 'DEVICE'">{{ triggerSingle.deviceMeasurement ? triggerSingle.deviceMeasurement.name : '' }}</p>
                    </td>
                    <td>
                      <span class="p-column-title bold">{{ 'attribute.valueEvaluated' | transloco }}</span>
                      {{ trigger.lastValueEvaluated }}
                    </td>
                    <td>
                      <span class="p-column-title bold">{{ 'attribute.condition' | transloco }}</span>
                      <p-tag severity="info" value="{{triggerSingle.type}}({{triggerSingle.expression}})"></p-tag>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex">
          <div class="my-auto">
            <div *ngIf="totalTriggers == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div *ngIf="totalTriggers > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalTriggers ? totalTriggers : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalTriggers}}
              {{(totalTriggers > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!deviceTriggers && loadingTriggers">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{ 'common.filters' | transloco }}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{ 'attribute.name' | transloco }}</label>
      </div>
      <div class="col-12">
        <input
          (keyup.enter)="filtersVisible = false; applyFilters()"
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          appAutoFocus
          class="w-full"
          id="name"
          pInputText
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{ 'attribute.active' | transloco }}</label>
      </div>
      <div class="col-12">
        <div class="p-field-radiobutton margin-top">
          <p-radioButton
            [(ngModel)]="currentFilters.active"
            [label]="'misc.allTypes' | transloco"
            name="active"
            value="null"
          ></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton
            [(ngModel)]="currentFilters.active"
            [label]="'misc.activeOnly' | transloco"
            name="active"
            value="true"
          ></p-radioButton>
        </div>
        <div class="p-field-radiobutton margin-top">
          <p-radioButton
            [(ngModel)]="currentFilters.active"
            [label]="'misc.inactiveOnly' | transloco"
            name="active"
            value="false"
          ></p-radioButton>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{ 'attribute.ruleType' | transloco }}</label>
      </div>
      <div class="col-12 flex flex-column">
        <div>
          <button
            (click)="setSelectedRuleType(null)"
            [ngClass]="currentFilters.isUserTrigger == null ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-circle-off"></i>
            {{ 'common.all' | transloco }}
          </button>
        </div>
        <div>
          <button
            (click)="setSelectedRuleType(true)"
            [ngClass]="currentFilters.isUserTrigger === true ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-user"></i>
            {{ 'common.user' | transloco }}
          </button>
        </div>
        <div>
          <button
            (click)="setSelectedRuleType(false)"
            [ngClass]="currentFilters.isUserTrigger === false ? 'btn-type btn-type-selected' : 'btn-type btn-type-not-selected'"
            pRipple
          >
            <i class="pi pi-cog"></i>
            {{ 'common.system' | transloco }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 p-mt-3">
      <p-button
        (onClick)="filtersVisible = false; applyFilters()"
        [disabled]="!(
          currentFilters.name ||
          (currentFilters.active != null) ||
          (currentFilters.isUserTrigger != null)
        )"
        [label]="'common.filter' | transloco"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        (click)="resetFilters(); filtersVisible = false;"
        [label]="'common.clear' | transloco"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
